import { render, staticRenderFns } from "./PopupBookingPoliciesWarning.vue?vue&type=template&id=7db46d15&scoped=true&"
import script from "./PopupBookingPoliciesWarning.vue?vue&type=script&lang=js&"
export * from "./PopupBookingPoliciesWarning.vue?vue&type=script&lang=js&"
import style0 from "./PopupBookingPoliciesWarning.vue?vue&type=style&index=0&id=7db46d15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db46d15",
  null
  
)

export default component.exports